


















import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Owner from "@/model/cospirit-api/Owner";

@Component
export default class OwnerSelect extends Vue {
    @Prop() public value!: string[]|string;

    @Getter("getOwners") public owners!: Owner[];
}
